<template>
    <div class="notice-container">
        <div v-if="props.data && props.data.length > 0">
            <ul class="notice-list">
                <li
                    class="notice-item pointer"
                    v-for="item in realList"
                    :key="item.contentId"
                    @click="goDetail(item)">
                    <div class="left-notice-wrap">

                    </div>
                    <div class="right-notice-wrap">
                        <p class="notice-time">{{item.publishTime}}</p>
                        <p class="text overflow-ellipsis" :title="item.contentTitle">
                            <span v-link="getDetailLink(item)">{{item.contentTitle}}</span>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
        <BigNoData
            v-else
            class="mar-top49"
            :width="180"
            :height="120"
            url="no-notice-gray@2x.png"
            info="暂无公告，静候通知"/>
    </div>
</template>

<script setup>
import BigNoData from '@/components/no-data.vue';
import { computed } from 'vue';
import { goNewsDetail, getLink } from '@/lib/tools.js';

const props = defineProps({
    data: { // 通知公告列表
        type: Array,
        default: () => []
    }
})

// 是否显示更多公告新闻
const realList = computed(() => {
    return props.data?.length && props.data.slice(0, 4) || [];
})

// 跳转公告详情页
function goDetail (info) {
    goNewsDetail(info, 'noticeDetail');
}

function getDetailLink(info){
    return getLink(info, 'noticeDetail');
}
</script>

<style lang="scss" scoped>
.notice-container {
    width: 100%;
    margin-top: 24px;
    .notice-list {
        font-size: 14px;
        .notice-item {
            display: flex;
            line-height: 14px;
            .left-notice-wrap {
                position: relative;
                margin-left: 2px;
                &::before {
                    content: '';
                    width: 7px;
                    height: 7px;
                    font-size: 0;
                    background-color: #91A5BA;
                    border-radius: 50%;
                    position: absolute;
                    left: -4px;
                    top: 0;
                }
                height: 56px;
                border-left: 1px dashed #C7D2DC;
            }
            .right-notice-wrap {
                margin-left: 14px;
                overflow: hidden;
                margin-top: -4px;
                .notice-time {
                    font-size: 12px;
                    color: #47698C;
                    line-height: 16px;
                }
                .text {
                    margin-top: 4px;
                    color: var(--srt-main-text-color);
                    line-height: 21px;
                    &:hover {
                        color: var(--srt-main-active-text-color);
                    }
                }
            }
        }
    }
    .mar-top49 {
        margin-top: 49px;
    }
}
</style>